export function Loader({ className }: { className?: string }) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`animate-spin ${className}`}
    >
      <path
        d="M14.75 8.00009C14.7499 9.42553 14.2986 10.8144 13.4607 11.9675C12.6228 13.1207 11.4413 13.979 10.0857 14.4195C8.72997 14.8599 7.26965 14.8599 5.91398 14.4193C4.55832 13.9788 3.37691 13.1204 2.53907 11.9672C1.70124 10.814 1.24999 9.42515 1.25 7.99971C1.25001 6.57427 1.70128 5.18542 2.53913 4.03221C3.37698 2.879 4.5584 2.02064 5.91407 1.58014C7.26974 1.13965 8.73007 1.13963 10.0858 1.58009"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
